import {createAsyncThunk} from '@reduxjs/toolkit'

import {qs} from '@shared/helpers/queryString'

import {PAY} from '@web/core/urls'
import {unsubscribeMessage, subscribeMessage, changeBrowserLocation, openPopup} from '@web/helpers/browser'
import {isMobile} from '@web/helpers/userAgent'

import {NavigationResult, NavigationTypeSelectableParam, ThunkApi} from '../interfaces'

const PointPrioritySettingMessage = {
    SettingsSaved: 'SettingsSaved',
    WindowClosed: 'WindowClosed',
    SaveError: 'SaveError',
} as const

const POINT_PRIORITY_SETTING_URL = `${PAY}/settings/point-priority`

const POPUP_KEY = 'POINT_PRIORITY_SETTING'
const MESSAGE_KEY = PointPrioritySettingMessage.SettingsSaved

/**
 * 포인트 우선 설정 페이지로 이동 액션
 * - 모바일: 페이지 이동
 * - PC: 팝업 오픈
 */
const navigateToPointPrioritySetting = createAsyncThunk<
    NavigationResult,
    NavigationTypeSelectableParam & {serviceId: 'order' | 'dicon' | 'nsp'},
    ThunkApi
>('navigateTo/pointPrioritySetting', async ({serviceId, forceLocationChange = false}) => {
    const shouldChangeLocation = forceLocationChange || isMobile

    if (shouldChangeLocation) {
        const url = qs.stringifyUrl({
            url: POINT_PRIORITY_SETTING_URL,
            query: {
                service: serviceId,
            },
        })

        changeBrowserLocation({
            url,
            type: 'PUSH',
        })
        // page 이동은 그 자체로 추가동작 없이 resolve 된다
        return Promise.resolve()
    }

    const popupUrl = qs.stringifyUrl({
        url: POINT_PRIORITY_SETTING_URL,
        query: {
            service: serviceId,
            popup: true,
        },
    })

    return new Promise<void | string>((resolve, reject) => {
        const resolveCallback = () => resolve(PointPrioritySettingMessage.SettingsSaved)

        // popup으로부터 유효한 메시지 받았을 때만 result로  메시지 전달
        subscribeMessage({messageKey: MESSAGE_KEY, subscriber: resolveCallback})

        // popup만 오픈
        openPopup({
            key: POPUP_KEY,
            url: popupUrl,
            size: {
                width: 500,
                height: 640,
            },
        })
            .then(() => resolve())
            .catch(reject)
            .finally(() => {
                // popup open 실패했든 종료했든 popup open시도가 끝났다면 message subscription 종료
                unsubscribeMessage({messageKey: MESSAGE_KEY, subscriber: resolveCallback})
            })
    })
})

export default navigateToPointPrioritySetting
